<template>
  <div v-if="isOtpVerification">
    <generic-modal
      :height="LoginModalDim.height"
      :width="LoginModalDim.width"
      :padding="LoginModalDim.padding"
      :paddingTop="LoginModalDim.paddingTop"
      :modalClass="
        checkIsPWACartDestination()
          ? LoginModalDim.modalClassLogin
          : LoginModalDim.modalClass
      "
      :background="[checkIsPWACartDestination() ? 'transparent' : '']"
      :backgroundBody="[checkIsPWACartDestination() ? 'white' : '']"
      :backgroundFooter="[checkIsPWACartDestination() ? 'white' : '']"
      :animationStyle="[
        checkIsPWACartDestination() ? 'slide-up-stick-bottom' : '',
      ]"
      @close="closeWelcomeLoginModal($event, '')"
    >
      <template v-slot:header>
        <!-- <div>
          <div class="header-component mb15 flex-row plr16">
            <skip-login :skip-text="'Skip'" />
          </div>
          <div class="plr16">
            <img :src="staticImgBaseUrl + '/images/global/logoLgTemplate.svg'" />
          </div>
        </div> -->
        <div
          v-if="!checkIsPWACartDestination() && showOnlySkip"
          class="skip-fix mb15"
        >
          <skip-login text-color="color-grey" parent-page="otp input" />
        </div>
        <login-carousel
          :landingOtp="true"
          :moduleProps="moduleProps"
          :show-carousel-img="showCarouselImg"
          v-if="!checkIsPWACartDestination() && !showOnlySkip"
        />
        <div v-else-if="checkIsPWACartDestination()">
          <img
            :src="staticImgBaseUrl + '/images/global/handle-bg.svg'"
            class="handle-bg"
          />
        </div>
      </template>
      <template v-slot:body>
        <div
          class="plr16 pt24"
          :class="checkIsPWACartDestination() ? 'mb64' : 'pb70'"
        >
          <div class="mb4 fs-14">
            <back-arrow
              @handleBackClick="handleBackClick"
              v-if="!checkIsPWACartDestination()"
            />
            <span class="pl8 bold">{{ modulePropsData?.headingText }}</span>
          </div>
          <!-- <div class="login-benefit-text" v-if="showLoggingIn">
            {{ modulePropsData?.loggingInText }} &nbsp;
            <div class="loading-sm"></div>
          </div>
          <div class="login-benefit-text" v-else-if="invalidOtp">
            {{ modulePropsData?.wrongOtpText }}
          </div>
          <div class="login-benefit-text" v-else>
            {{ modulePropsData?.enterOtpText }}
          </div> -->
          <div class="otp-input-container">
            <otp-input
              ref="otpInput"
              class="gap16"
              :input-classes="invalidOtp ? 'otp-input invalid' : 'otp-input'"
              :num-inputs="6"
              :should-auto-focus="true"
              :is-input-num="true"
              input-type="number"
              v-model="otpValue"
              separator=""
              @on-change="handleOnChange"
              @on-complete="handleOnChange"
              @on-handle-focus="doViewPortChanges"
              @on-handle-blur="removeViewPortChanges"
            />
          </div>
          <div v-if="invalidOtp" class="otp-invalid-text">
            {{ modulePropsData?.incorrectOtpTryAgainText }}
          </div>
          <div
            v-if="!invalidOtp"
            class="otp-sent-text"
            :class="{ mt18: invalidOtp }"
          >
            {{ modulePropsData?.otpSentInfoText }} {{ mobileNo }}&nbsp;
            <span
              @click="handleBackClick($event)"
              class="color-teal-secondary bold"
              >{{ modulePropsData?.changeNumberCtaText }}</span
            >
          </div>
          <div v-if="disableResendSMS" class="resend-sms-counter">
            <span class="resend-sms-disabled">{{
              modulePropsData?.resendOtpCtaText
            }}</span
            >&nbsp;in
            {{ prettifyTimer(timerCount) }}
          </div>
          <span
            v-if="!disableResendSMS"
            class="resend-sms-enabled color-teal-secondary"
            @click="handleResendSMS($event)"
            >{{ modulePropsData?.resendOtpCtaText }}</span
          >
        </div>
      </template>
      <template v-slot:footer>
        <button
          class="login-button bold d-flex align-items-center justify-content-center"
          :class="{
            'color-white': disableLogin,
            mt0: checkIsPWACartDestination(),
          }"
          :disabled="disableLogin"
          @click="handleSubmitOTP($event)"
        >
          <span :class="{ pr5: !disableLogin }">
            {{
              disableLogin
                ? modulePropsData?.submitOtpButtonText
                : modulePropsData?.submitOtpEnabledButtonText
            }}</span
          >
          <span class="loading-sm-white" v-if="!disableLogin"></span>
        </button>
      </template>
    </generic-modal>
  </div>
</template>

<script>
// import VOtpInput from "vue3-otp-input";
import OtpInput from "./reusableComponents/OtpInput.vue";
import GenericModal from "./GenericModal.vue";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { clientPlatform, staticImgBaseUrl } from "../config/apiEndpoints";
import { keyMapsMutation, keyMapsAction } from "../helpers/storeKeys";
import { LoginStates, LoginStateStatus } from "../helpers/loginStateConstants";
import fingerPrintInstance from "../store/storeInitializer/initialiseFingerprint";
import { collectData } from "../helpers/fingerPrintHelper";
import Utility from "../helpers/utility";
import LoginCarousel from "./LoginCarousel.vue";
import {
  EVENT_CLICK_CHANGEMOBILENUMBER,
  EVENT_CLICK_RESENDSMS,
  EVENT_OTP_DETECTED,
  EVENT_TYPE_OTP,
} from "../helpers/analyticsEvents";
import { autoReadSMS } from "../helpers/loginUtils";
import BackArrow from "./BackArrow.vue";
import SkipLogin from "./SkipLogin.vue";

const mediaHeightIsSmaller = window.matchMedia("(max-height: 1000px)").matches;
export default {
  name: "OtpVerification",
  components: {
    OtpInput,
    GenericModal,
    BackArrow,
    SkipLogin,
    LoginCarousel,
  },
  props: {
    // counterLimit is time in seconds for timer
    adDisable: false,
    moduleProps: {},
  },
  data() {
    return {
      LoginModalDim: {
        width: "100vw",
        padding: "0px",
        paddingTop: "0px",
        modalClass: "login-modal full-screen-popup lg-screen-centered",
        modalClassLogin:
          "login-modal full-screen-popup lg-screen-centered cart-my-login",
      },
      timerCount: 0,
      otpValue: "",
      otpEnterEventProcessed: false,
      modulePropsData: {},
      clientPlatform,
      staticImgBaseUrl,
      counterLimit: 0,
      showCarouselImg: true,
      showOnlySkip: false,
      otpVerificationTriggerred: false,
    };
  },
  watch: {
    timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.timerCount--;
            if (!this.autoReadDisable) {
              autoReadSMS((otp, signal) => {
                if (otp) {
                  this.otpValue = otp;
                  this.$refs.otpInput.otp = otp.split("");
                  this.autoReadDisable = true;
                  if (otp.length == 6) {
                    EVENT_OTP_DETECTED({ category: "auto-detect app" });
                    this.handleSubmitOTP(false, true);
                  }
                  signal.abort();
                }
              });
            }
          }, 1000);
        }
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
  },
  mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};

    this.counterLimit =
      this.modulePropsData?.timeCount || this.modulePropsData?.timerCount;
  },
  methods: {
    resetTimer() {
      this.timerCount = this.counterLimit;
    },
    handleOnChange(value) {
      if (this.otpValue && !this.otpEnterEventProcessed) {
        this.otpEnterEventProcessed = true;
        EVENT_OTP_DETECTED({ category: "manual" });
        EVENT_TYPE_OTP({ loginMethod: "manual" });
      }
      if (
        this.$store.state.Auth.loginStateStatus ==
        LoginStateStatus.VALIDATED_OTP_INVALID
      ) {
        this.$store.commit(keyMapsMutation.UPDATE_LOGIN_STATE_STATUS, "");
      }
      this.otpValue = value;
      if (value.length === 6) {
        EVENT_OTP_DETECTED({ category: "manual" });
        this.handleSubmitOTP();
      }
    },
    handleResendSMS(e) {
      EVENT_CLICK_RESENDSMS({ loginMethod: "manual" });
      this.otpValue = "";
      this.resetTimer();
      const { getFPInstance } = fingerPrintInstance;
      collectData({ detector: getFPInstance() }).then((response) => {
        const payload = {
          detectorData: response,
        };
        this.$store.dispatch(keyMapsAction.SEND_FINGER_PRINT, payload);
        setTimeout(() => {
          this.$store.dispatch(keyMapsAction.FORGOT_PASSWORD_API, {
            mobile: LocalStorageFunc.getUserMobileNo(),
            hash: this.hashKey?.key,
            id: this.hashKey?.id,
          });
        }, 1000);
      });
    },
    handleSubmitOTP(e, autoDetect = false) {
      if (!this.otpVerificationTriggerred) {
        this.otpVerificationTriggerred = true;
        this.$store.dispatch(keyMapsAction.VALIDATE_OTP_API, {
          mobile: LocalStorageFunc.getUserMobileNo(),
          code: this.otpValue,
          screenName: "LOGIN",
          autologin: !e,
          autoDetect,
        });
      }
    },
    handleBackClick(e) {
      clearTimeout(this.timerCount);
      const { getFPInstance } = fingerPrintInstance;
      collectData({ detector: getFPInstance() }).then((response) => {
        const payload = {
          detectorData: response,
        };
        this.$store.dispatch(keyMapsAction.SEND_FINGER_PRINT, payload);
      });
      this.$store.commit(keyMapsMutation.UPDATE_LOCAL_STORAGE_USER_DATA, {
        mobile: "",
      });
      this.$store.commit(keyMapsMutation.UPDATE_LOGIN_STATE_STATUS, "");
      EVENT_CLICK_CHANGEMOBILENUMBER({ loginMethod: "manual" });
      this.$store.commit(
        keyMapsMutation.UPDATE_CURRENT_LOGIN_STATE,
        LoginStates.welcomeLogin
      );
    },
    checkIsCartDestination() {
      return Utility.isCurrentlyAtUrl("/cart");
    },
    checkIsPWACartDestination() {
      return this.checkIsCartDestination() && this.clientPlatform !== "Web";
    },
    prettifyTimer(value) {
      let minutes = value > 59 ? Math.trunc(value / 60) : 0;
      let secondes = value % 60;
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      if (secondes < 10) {
        secondes = "0" + secondes;
      }
      return minutes + ":" + secondes;
    },
    closeWelcomeLoginModal(e) {
      e.stopPropagation();
      document.body.classList.remove("body-stop-scroll-mobile");
      this.$store.commit(
        keyMapsMutation.UPDATE_CURRENT_LOGIN_STATE,
        LoginStates.onboarding
      );
    },
    doViewPortChanges() {
      if (clientPlatform !== "Web") {
        document.body.classList.add("keyboard-in-view");
        if (mediaHeightIsSmaller) {
          this.showCarouselImg = false;
        }
        this.showOnlySkipBasedOnSmallScreenSize();
      }
    },
    removeViewPortChanges() {
      document.body.classList.remove("keyboard-in-view");
      this.showCarouselImg = true;
      this.showOnlySkip = false;
    },
    showOnlySkipBasedOnSmallScreenSize() {
      if (window.document.getElementsByClassName("modal-header")[0]) {
        let computedStyles = window.getComputedStyle(
          window.document.getElementsByClassName("modal-header")[0]
        );
        let calculatedParentHeight = parseInt(
          computedStyles.height.replace("px", "")
        );

        let requiredHeight =
          parseInt(computedStyles.width.replace("px", "")) * 0.52;
        // console.log(window.getComputedStyle(el));
        this.showOnlySkip = calculatedParentHeight < requiredHeight;
      } else {
        this.showOnlySkip = false;
      }
    },
  },
  computed: {
    disableResendSMS() {
      return this.timerCount > 0;
    },
    disableLogin() {
      return (
        this.otpValue.length < 6 ||
        this.$store.state.Auth.loginStateStatus ==
          LoginStateStatus.VALIDATING_OTP ||
        this.$store.state.Auth.loginStateStatus ==
          LoginStateStatus.VALIDATED_OTP_INVALID
      );
    },
    mobileNo() {
      return this.$store.state.Auth.mobileNo;
    },
    showLoggingIn() {
      return (
        this.$store.state.Auth.loginStateStatus ==
        LoginStateStatus.VALIDATING_OTP
      );
    },
    invalidOtp() {
      if (
        this.$store.state.Auth.loginStateStatus ==
        LoginStateStatus.VALIDATED_OTP_INVALID
      ) {
        this.otpVerificationTriggerred = false;
      }
      return (
        this.$store.state.Auth.loginStateStatus ==
        LoginStateStatus.VALIDATED_OTP_INVALID
      );
    },
    hashKey() {
      return this.$store.state.FingerPrint.hashKey;
    },
    isOtpVerification() {
      let flag =
        clientPlatform == "Web"
          ? this.$store.state.Auth.currentLoginState ===
              LoginStates.otpVerification &&
            this.$store.state.Auth.showProfileDrawerModal
          : this.$store.state.Auth.currentLoginState ===
            LoginStates.otpVerification;
      if (flag) {
        this.timerCount = this.counterLimit;
      }
      return flag;
    },
  },
};
</script>
